var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "order-detail-dialog",
      attrs: {
        title: "订单详情",
        visible: _vm.visible,
        width: "80%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "order-detail",
          attrs: { "element-loading-text": "正在加载订单详情..." },
        },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c("div", { staticClass: "detail-section" }, [
              _c("h3", { staticClass: "section-title" }, [_vm._v("基础信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "info-grid" }, [
                _c("div", { staticClass: "info-column" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("交易订单号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.orderNo)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("商家订单号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.outTradeNo)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("交易发起时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.payStartTime)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("下单用户："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.userName)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-column" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单状态："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "value" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusType(_vm.orderDetail.status),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.getStatusLabel(_vm.orderDetail.status)
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("交易完成时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.payOverTime)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("成交小程序："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.orderDetail.appName)),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-section" }, [
              _c("h3", { staticClass: "section-title" }, [_vm._v("交易信息")]),
              _vm._v(" "),
              _c("div", { staticClass: "info-grid" }, [
                _c("div", { staticClass: "info-column" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单金额："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "value" },
                      [
                        _c("span", { staticClass: "money-value" }, [
                          _vm._v(
                            "¥" + _vm._s(_vm.orderDetail.orderAmount || 0)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "money-value" }, [
                          _vm._v(
                            _vm._s(
                              "（福豆：￥" +
                                (_vm.orderDetail.useIntegral || 0) +
                                "，微信：￥" +
                                (_vm.orderDetail.paidAmount || 0) +
                                "）"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-link",
                          {
                            staticClass: "fudou-link",
                            attrs: { type: "primary" },
                            on: { click: _vm.viewFudou },
                          },
                          [_vm._v("查看福豆")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("优惠方式："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "value" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.orderDetail.discountType
                                ? _vm.orderDetail.discountType == 1
                                  ? "立减"
                                  : "优惠券"
                                : "未知"
                            ) +
                            "\n              "
                        ),
                        _c(
                          "el-link",
                          {
                            staticClass: "discount-link",
                            attrs: { type: "primary" },
                            on: { click: _vm.viewDiscountRecord },
                          },
                          [_vm._v("优惠记录")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-column" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.orderDetail.discountType == 1
                            ? "立减金额："
                            : "优惠券金额："
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _c("span", { staticClass: "money-value" }, [
                        _vm._v(
                          "¥" +
                            _vm._s(
                              _vm.orderDetail.discountType
                                ? _vm.orderDetail.discountType == 1
                                  ? _vm.orderDetail.immediateDiscountAmount
                                  : _vm.orderDetail.couponDiscountAmount
                                : "-"
                            )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.orderDetail.stationOrder && _vm.orderDetail.stationOrder[0]
              ? _c("div", { staticClass: "detail-section" }, [
                  _c("h3", { staticClass: "section-title" }, [
                    _vm._v("第三方订单信息"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "info-column" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("商家："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].merchant || "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("门店地址："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].storeAddress ||
                                "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("油品名称："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].oilName || "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("油枪名称："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].gunName || "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("车牌号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].licensePlate ||
                                "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _c("span", { staticClass: "money-value" }, [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.orderDetail.stationOrder[0].money / 100 ||
                                    "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("实付金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _c("span", { staticClass: "money-value" }, [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.orderDetail.stationOrder[0].payMoney /
                                    100 || "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-column" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("门店："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].stationName || "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("加油订单唯一编号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].serialCode || "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("会员编号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].userCode || "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("油枪编号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(_vm.orderDetail.stationOrder[0].gunNo || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("升数："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.stationOrder[0].litter + "L" ||
                                "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("单价："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _c("span", { staticClass: "money-value" }, [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.orderDetail.stationOrder[0].unitPirce /
                                    100 || "-"
                                ) +
                                "/L"
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("优惠金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _c("span", { staticClass: "money-value" }, [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.orderDetail.stationOrder[0]
                                    .discountMoney / 100 || "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderDetail.refundAmount > 0
              ? _c("div", { staticClass: "detail-section" }, [
                  _c("h3", { staticClass: "section-title" }, [
                    _vm._v("退款详情"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "info-column" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("退款类型："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.orderDetail.refundStatus == 8
                                ? "全额退款"
                                : "部分退款"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "info-column" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("退款金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _c("span", { staticClass: "money-value" }, [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.orderDetail.refundAmount +
                                    "（福豆：" +
                                    _vm.orderDetail.refundUseIntegral +
                                    "，微信：" +
                                    _vm.orderDetail.refundPaidAmount +
                                    "）" || "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderDetail.stationOrder &&
            _vm.orderDetail.stationOrder[0].goodsList
              ? _c(
                  "div",
                  { staticClass: "detail-section" },
                  [
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v("商品详情"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        staticClass: "product-table",
                        attrs: {
                          data: _vm.orderDetail.stationOrder[0].goodsList,
                          size: "small",
                          "header-cell-style": { fontWeight: "bold" },
                          stripe: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "goodsName", label: "商品名称" },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "", label: "商品类型" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [_c("span", [_vm._v("油")])]
                                },
                              },
                            ],
                            null,
                            false,
                            2618622450
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "", label: "商品数量" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          (
                                            scope.row.payMoney /
                                            scope.row.unitPirce
                                          ).toFixed(2) + "L"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1653292556
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "", label: "商品单价" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.unitPirce
                                      ? _c(
                                          "span",
                                          { staticClass: "money-value" },
                                          [
                                            _vm._v(
                                              "¥" +
                                                _vm._s(
                                                  scope.row.unitPirce / 100
                                                )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4028292953
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orderGoodsId",
                            label: "商品编号",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "", label: "订单金额" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "money-value" }, [
                                      _vm._v(
                                        "¥" + _vm._s(scope.row.money / 100)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            21492758
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "payMoney", label: "实付金额" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "money-value" }, [
                                      _vm._v(
                                        "¥" + _vm._s(scope.row.payMoney / 100)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1833819774
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "discountAmount", label: "优惠金额" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "money-value" }, [
                                      _vm._v(
                                        "¥" +
                                          _vm._s(scope.row.discountMoney / 100)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2401754603
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [_c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("关闭")])],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "fudou-dialog",
          attrs: {
            title: "福豆使用记录",
            visible: _vm.fudouDialogVisible,
            width: "90%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.fudouDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.fudouRecordList,
                size: "small",
                stripe: "",
                border: "",
                "header-cell-style": {
                  fontWeight: "bold",
                  background: "#f5f7fa",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "交易订单号",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cardId", label: "卡ID", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cardName",
                  label: "卡片名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderName",
                  label: "卡片项目名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type", label: "交易类型", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: _vm.getTransactionTypeTag(scope.row.type),
                            },
                          },
                          [
                            _c("i", {
                              class: _vm.getTransactionTypeIcon(scope.row.type),
                              staticStyle: { "margin-right": "5px" },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getTransactionTypeText(scope.row.type)
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "integral",
                  label: "交易金额",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "money-value" }, [
                          _vm._v("¥" + _vm._s(scope.row.integral || 0)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: "用户姓名",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", "min-width": "140" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "交易时间",
                  "min-width": "180",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.fudouDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "discount-dialog",
          attrs: {
            title: "优惠记录",
            visible: _vm.discountDialogVisible,
            width: "50%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.discountDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "discount-info-wrapper" }, [
            _c("div", { staticClass: "discount-field" }, [
              _c("div", { staticClass: "field-label" }, [_vm._v("优惠信息：")]),
              _vm._v(" "),
              _c("div", { staticClass: "field-value" }, [
                _vm._v(_vm._s(_vm.orderDetail.discountInfo || "-")),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "discount-field" }, [
              _c("div", { staticClass: "field-label" }, [_vm._v("优惠金额：")]),
              _vm._v(" "),
              _c("div", { staticClass: "field-value" }, [
                _c("span", { staticClass: "money-value" }, [
                  _vm._v(
                    "¥" +
                      _vm._s(
                        _vm.orderDetail.discountType == 1
                          ? _vm.orderDetail.immediateDiscountAmount
                          : _vm.orderDetail.couponDiscountAmount || 0
                      )
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.discountDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }